<template>
  <div ref="form" class="app-container">
    <BjDivider>
      {{ $t('BusinessPurchaseComponentsPur.information') }}
      <template #right>
        <el-button @click="cancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
      </template>
      <template>
        <el-button type="primary" @click="onAdd">{{ $t('BusinessPurchaseComponentsPur.addingGoods') }}</el-button>
        <el-button :disabled="selection.length === 0" @click="onDelete()">{{ $t('delText') }}</el-button>
      </template>
    </BjDivider>
    <div class="bj-col bj-col-24" style="border-left:none">
      <el-table :data="goodsList" border script max-height="600px" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="70" align="center" fixed="left" />
        <el-table-column prop="standardSkuCode" label="SKU" align="center" fixed="left" min-width="170" />
        <el-table-column prop="length" align="center" min-width="150">
          <template #header>
            <span class="red">*</span> {{ $t('goodsPage.length') }}
          </template>
          <template slot-scope="{ row }">
            <BjInputMoney v-model="row.length" :min="0" class="full-width" :controls="false">
              <template slot="append">cm</template>
            </BjInputMoney>
          </template>
        </el-table-column>
        <el-table-column prop="width" align="center" min-width="150">
          <template #header>
            <span class="red">*</span> {{ $t('goodsPage.width') }}
          </template>
          <template slot-scope="{ row }">
            <BjInputMoney v-model="row.width" :min="0" class="full-width" :controls="false">
              <template slot="append">cm</template>
            </BjInputMoney>
          </template>
        </el-table-column>
        <el-table-column prop="height" align="center" min-width="150">
          <template #header>
            <span class="red">*</span> {{ $t('goodsPage.height') }}
          </template>
          <template slot-scope="{ row }">
            <BjInputMoney v-model="row.height" :min="0" class="full-width" :controls="false">
              <template slot="append">cm</template>
            </BjInputMoney>
          </template>
        </el-table-column>
        <el-table-column prop="weight" align="center" min-width="150">
          <template #header>
            <span class="red">*</span> {{ $t('goodsPage.weight') }}
          </template>
          <template slot-scope="{ row }">
            <BjInputMoney v-model="row.weight" :min="0" class="full-width" :controls="false">
              <template slot="append">kg</template>
            </BjInputMoney>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.operationText')" align="center">
          <template slot-scope="{ row, $index }">
            <el-button @click="onDelete(row, $index)">{{ $t('delText') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <chooseSku ref="chooseSkuRef" @submit="onAddDialogConfirm" />
  </div>
</template>
<script>

import { purchaseApi, goodsApi } from '@/api';
import viewMiXin from '@/utils/view-mixin.js';
import chooseSku from '../components/chooseSku';

export default {
  name: 'BusinessPurchaseOrderCsgAdminVerify',
  components: { chooseSku },
  mixins: [viewMiXin],
  data() {
    return {
      goodsList: [],
      selection: [],
      SKU_LIST: [],
    };
  },
  methods: {
    handleConfirm() {
      const skuInfoList = [];
      if (this.goodsList.length == 0) {
        this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg4'));
        return;
      }
      for (const item of this.goodsList) {
        if (!item.length || !item.width || !item.height || !item.weight) {
          this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg3'));
          return;
        }
        skuInfoList.push({
          skuCode: item.skuCode,
          length: item.length,
          width: item.width,
          height: item.height,
          weight: item.weight
        });
      }
      this.toApi(skuInfoList);
    },
    async toApi(DATA) {
      const res = await goodsApi.skuDimensionsCheck({skuInfoList: DATA});
      if (!res.length) return;
      const DATA2 = [];
      this.goodsList.forEach(item => {
        res.map(item2 => {
          if (item2.skuCode === item.skuCode) {
            DATA2.push({
              id: item.id,
              checkStatus: item2.checkStatus ? 1 : 2
            });
          }
        });
      });
      purchaseApi.purchaseOrderGoodsSizeCheck(DATA2).then(res1 => {
        if (!res1.failed) {
          this.$message.success(res1.message);
          this.goodsList = [];
          setTimeout(() => {
            this.cancel();
          }, 500);
        }
      });
    },
    onAddDialogConfirm(data) {
      if (this.goodsList.length > 0) {
        const newData = data;
        const oldData = this.goodsList;
        const differentItems = this.$lodash.differenceBy(newData, oldData, 'skuCode');
        if (differentItems.length) {
          differentItems.forEach(item => {
            this.$set(item, 'length', 0);
            this.$set(item, 'width', 0);
            this.$set(item, 'height', 0);
            this.$set(item, 'weight', 0);
          });
        }
        this.goodsList = [...oldData, ...differentItems];
      } else {
        this.goodsList = data;
        this.goodsList.forEach(item => {
          this.$set(item, 'length', 0);
          this.$set(item, 'width', 0);
          this.$set(item, 'height', 0);
          this.$set(item, 'weight', 0);
        });
      }
      this.$refs.chooseSkuRef.visible = false;
    },
    onAdd() {
      this.$refs.chooseSkuRef.visible = true;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        row
          ? this.goodsList.splice(index, 1)
          : (this.goodsList = this.goodsList.filter(
            row => !this.selection.map(e => e.skuCode).includes(row.skuCode),
          ));
      });
    },
  },
};
</script>
